var React = require('react');

function Attention (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"63.83","cy":"64.06","r":"56","key":0}),React.createElement("polygon",{"points":"55.99 26.96 72.59 26.96 64.67 79.99 55.99 26.96","key":1}),React.createElement("circle",{"cx":"64.29","cy":"95.21","r":"5.99","key":2})]);
}

Attention.defaultProps = {"className":"svg-attention","viewBox":"0 0 128 128","stroke":"#000000","fill":"none"};

module.exports = Attention;

Attention.default = Attention;
